import React, { useEffect, useState } from "react";
import Layout from "../components/Layout";
import PageTitle from "../components/PageTitle";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { useDispatch, useSelector } from "react-redux";
import { addConsul } from "../redux/actions/honararyConsulAction";
import { useNavigate } from "react-router-dom";
import { CONSUL_ADD_RESET } from "../redux/constants/honararyConsulConstant";
import axios from "axios";
import { baseUrl } from "../utils/env";

const AddHonororyConsulScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const consulAdd = useSelector((state) => state.consulAdd);
  const { adminInfo } = useSelector((state) => state.adminLogin);
  const { success } = consulAdd;
  const [name, setName] = useState("");
  const [joinDate, setJoinDate] = useState("");
  const [image, setImage] = useState("");
  const [description, setDescription] = useState("");
  const [uploading, setUploading] = useState(false);
  const [previewSource, setPreviewSource] = useState();

  const handleCkEditorChange = (e, editor) => {
    setDescription(editor.getData());
  };
  const handleSubmitForm = (e) => {
    e.preventDefault();
    dispatch(addConsul(name, joinDate, image, description));
  };

  useEffect(() => {
    if (success) {
      navigate("/honorary-consul");
      dispatch({ type: CONSUL_ADD_RESET });
    }
  }, [success]);

  const previewFile = (file) => {
    console.log(file);
    const reader = new FileReader();
    if (file) {
      reader.readAsDataURL(file);
    }
    reader.onloadend = () => {
      setPreviewSource(reader.result);
    };
  };

  const uploadFileHandler = async (e) => {
    const file = e.target.files[0];
    previewFile(file);
    const formData = new FormData();
    formData.append("image", file);
    setUploading(true);

    try {
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${adminInfo.token}`,
        },
      };

      const { data } = await axios.post(`${baseUrl}/upload`, formData, config);

      setImage(data[0].path);
      setUploading(false);
      // console.log("imageData", data);
    } catch (err) {
      console.error(err);
      setUploading(false);
    }
  };
  return (
    <Layout>
      <PageTitle title="Add New Honorory Consul" />
      <div className="card">
        <div className="card-body">
          <form onSubmit={handleSubmitForm} encType="multipart/form-data">
            <div className="row mb-3">
              <label htmlFor="name" className="col-sm-2 col-form-label">
                Full Name
              </label>
              <div className="col-sm-10">
                <input
                  className="form-control"
                  type="text"
                  placeholder="Enter Name Of Hpnorory Consul"
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
            </div>
            <div className="row mb-3">
              <label
                htmlFor="example-week-input"
                className="col-sm-2 col-form-label"
              >
                Join Date
              </label>
              <div className="col-sm-10">
                <input
                  className="form-control"
                  type="date"
                  id="example-week-input"
                  onChange={(e) => setJoinDate(e.target.value)}
                />
              </div>
            </div>
            <div className="row mb-3">
              <label
                htmlFor="example-search-input"
                className="col-sm-2 col-form-label"
              >
                Choose Image
              </label>
              <div className="col-sm-10">
                <input
                  className="form-control"
                  type="file"
                  onChange={uploadFileHandler}
                />
                {previewSource && (
                  <div className="previewImage">
                    <img src={previewSource} alt="profile" />
                  </div>
                )}
              </div>
            </div>
            <div className="row mb-3">
              <label htmlFor="name" className="col-sm-2 col-form-label">
                Description
              </label>
            </div>
            <div className="col-12 mb-3">
              <CKEditor
                editor={ClassicEditor}
                class="form-control"
                placeholder="Description of Job"
                onChange={(e, editor) => {
                  handleCkEditorChange(e, editor);
                }}
              />
            </div>
            <button type="submit" className="btn btn-primary">
              Add New Honorary Consul
            </button>
          </form>
        </div>
      </div>
    </Layout>
  );
};

export default AddHonororyConsulScreen;
